import ServiceBase from "./BaseService";

class ServiceDocument extends ServiceBase {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/document";
	}

	createContract(details) {
		const url = this.serviceUrl + `/pdf`;
		return this.opencellAPI.invokeRequest(details, url, "POST");
	}

	createProcedure(procedure) {
		const url = this.serviceUrl + "/sign/procedures";
		return this.opencellAPI.invokeRequest(procedure, url, "POST");
	}

	getProcedureById(procedureId) {
		const url = this.serviceUrl + `/sign/procedures/${procedureId}`;
		return this.opencellAPI.callApi(url);
	}

	getProcedureStatusById(procedureId) {
		const url = this.serviceUrl + `/sign/procedures/${procedureId}/status`;
		return this.opencellAPI.callApi(url);
	}

}

const serviceDocument = new ServiceDocument();
export default serviceDocument;



// WEBPACK FOOTER //
// ./src/opencell/services/ServiceDocument.js